import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef, Inject,
  Input,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'synapi-item-modal-fairguest',
  standalone: true,
  imports: [],
  templateUrl: './synapi-item-modal-fairguest.component.html',
  styleUrl: './synapi-item-modal-fairguest.component.scss',
  host: {ngSkipHydration: 'true'},
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class SynapiItemModalFairguestComponent implements AfterViewInit{
  @Input() item: SynapiItem;
  @ViewChild('widgetContainer', { static: true }) widgetContainer: ElementRef;
  constructor(private renderer: Renderer2,@Inject(DOCUMENT) private document: Document,private el: ElementRef) {
  }
  ngAfterViewInit(): void {
    this.loadFairguestWidget();
    this.observeWidgetChanges();
  }

  async loadFairguestWidget() {
    this.reloadScript();
    this.el.nativeElement.innerHTML = '<rc-fairguest-widget-destination id="1397" lang="fr-FR" sheet="sitra2i-FGPACA-'+this.item.ExternalId+'" type="default"></rc-fairguest-widget-destination>';
  }

  observeWidgetChanges() {
    const observer = new MutationObserver((mutationsList, observer) => {
      for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          this.reloadScript();
        }
      }
    });

    observer.observe(this.el.nativeElement, { childList: true });
  }

  reloadScript() {
    const existingScript = this.document.getElementById('fairguestScript');
    if (existingScript) {
      existingScript.remove();
    }
    this.loadScript();
  }

  loadScript() {
    const script = this.renderer.createElement('script');
    script.type = 'module';
    script.id = 'fairguestScript';
    script.text = `(async () => (await import("https://www.fairguest.com/api/v2/fairguest/widgets/1397/js")).load())();`;
    this.document.head.append(script);
  }

}
